const CSM_EMAIL = 'equipecsm@explain.fr';

export enum ContactReason {
  TrialEnding = 'trialEnding',
  CreditsOut = 'creditsOut',
  TrialEnded = 'trialEnded',
  Expired = 'expired',
}

const MAILTO_CONFIGS: Record<ContactReason, { subject: string; body: string }> = {
  [ContactReason.TrialEnding]: {
    subject: 'Explain Réponse : passer en abonnement',
    body: 'Bonjour,%0A%0AMon essai Explain Réponse se termine bientôt. Je souhaite échanger sur les conditions pour continuer.%0A%0AMerci',
  },
  [ContactReason.CreditsOut]: {
    subject: 'Explain Réponse : crédits supplémentaires',
    body: "Bonjour,%0A%0AJ'ai consommé tous mes crédits Explain Réponse et je souhaite en obtenir davantage.%0A%0AMerci",
  },
  [ContactReason.TrialEnded]: {
    subject: 'Explain Réponse : activer mon abonnement',
    body: 'Bonjour,%0A%0AMon essai Explain Réponse est terminé. Je souhaite activer mon abonnement pour reprendre mes projets.%0A%0AMerci',
  },
  [ContactReason.Expired]: {
    subject: 'Explain Réponse : renouveler mon abonnement',
    body: 'Bonjour,%0A%0AMon abonnement Explain Réponse a expiré. Je souhaite le renouveler pour reprendre mes projets.%0A%0AMerci',
  },
};

export function getCsmMailtoHref(reason: ContactReason): string {
  const { subject, body } = MAILTO_CONFIGS[reason];
  return `mailto:${CSM_EMAIL}?subject=${encodeURIComponent(subject)}&body=${body}`;
}
